export const css = `
  @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200;500;600&display=swap');
`;
